import { Component, OnInit } from '@angular/core';
import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { ContactusService } from "../../_services/contactus.service";
import {Ng4LoadingSpinnerService} from "ng4-loading-spinner";
import {ExcelServicesService} from "../../_services/excel-services.service";

declare var $: any;

@Component({
  selector: 'app-pandemic-care',
  templateUrl: './pandemic-care.component.html',
  styleUrls: ['./pandemic-care.component.css']
})
export class PandemicCareComponent implements OnInit {

  returnUrl: string;
  userdetaild: string;
  pandemicList: any[] = [];
  userid: string;
  contactlist_data: any[] = [];

  constructor(private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private contactusService: ContactusService, private spinnerService: Ng4LoadingSpinnerService,private excelService: ExcelServicesService) { }

  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] !== 'admin') {
      this.authenicationService.logout();
      this.router.navigateByUrl('/login');
    }



    this.getPandemicCareList();

  }

  exportAsXLSX():void {
    this.spinnerService.show();
    this.excelService.exportAsExcelFile(this.contactlist_data, `customers_pandemicCare`);
    this.spinnerService.hide();
  }

  getPandemicCareList() {
    this.contactusService.getPandemicCareList()
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.pandemicList = data.Data;
            this.pandemicList.forEach((row: any) => {
              const userdata = {
                Name: (row['name'])?row['name']:'',
                Contact: (row['phone'])?row['phone']:row['email'],
                Date: (row['createdAt'])?row['createdAt']:'',
              };
              this.contactlist_data.push(userdata);
            });
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          } else {
            this.toaster.showError('WishList', data.ResponseMessage);
            setTimeout(()=>{
              $(function() {
                $('#example').DataTable();
              });
            }, 1000);
          }
          // this.router.navigate([this.returnUrl]);
        },
        error => {
          this.toaster.showError('WishList', error.error.ResponseMessage);
          setTimeout(()=>{
            $(function() {
              $('#example').DataTable();
            });
          }, 1000);
        });
  }


}
